import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { selectors } from '../reducer';
import MoreOffers from './MoreOffers';
import PrimePrequalApproval from './PrimePrequalApproval';
function ImprintPresentedOffer({ offers, practiceName, handleAcceptOffer, activeOffer, }) {
    const offerScreen = useSelector(selectors.offerScreen);
    const offerToUse = activeOffer ? activeOffer : offers[0];
    return (_jsx(_Fragment, { children: offerScreen === 'PRESENTED OFFER' ? (_jsx(PrimePrequalApproval, { handleAcceptOffer: handleAcceptOffer, practiceName: practiceName, offer: offerToUse, approvalAmount: offerToUse.amount, hasMultipleOffers: offers.length > 1 })) : (_jsx(MoreOffers, { offers: offers })) }));
}
export default ImprintPresentedOffer;
